import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Icon } from 'semantic-ui-react';
import classnames from 'classnames';
import styles from './notification.module.scss';

const Notification = (props) => {
  const {
    message,
    notificationType,
    closeToast,
  } = props;

  const { t } = useTranslation();

  let icon;
  let cn;
  if (notificationType === 'error') {
    icon = 'warning circle';
    cn = styles.notificationErrorIcon;
  } else if (notificationType === 'success') {
    icon = 'check circle';
    cn = styles.notificationSuccessIcon;
  } else if (notificationType === 'info') {
    icon = 'info circle';
    cn = styles.notificationInfoIcon;
  }

  return (
    <div
      className={classnames(
        styles.notification,
        styles[notificationType],
      )}
    >
      <div className={styles.notificationWrapper}>
        <div className={`${styles.notificationTypeIndicator}`}>
          <Icon className={cn} name={icon} />
        </div>
        <span className={styles.message}>
          {message && t(message)}
        </span>
      </div>

      <div className={styles.closeButton}>
        <Icon name="close" onClick={closeToast} />
      </div>
    </div>
  );
};

Notification.propTypes = {
  message: PropTypes.string.isRequired,
  notificationType: PropTypes.oneOf(['error', 'success', 'info']).isRequired,
  closeToast: PropTypes.func,
};

Notification.defaultProps = {
  closeToast: () => {},
};

export default Notification;
